/** NextAuth `useSession()` status values. */
export const SESSION_STATUS = {
  AUTHENTICATED: 'authenticated',
  UNAUTHENTICATED: 'unauthenticated',
  LOADING: 'loading',
} as const;

/** NextAuth provider ID for Microsoft Entra External ID. */
export const AUTH_PROVIDER = 'entra-external-id' as const;

/**
 * `session.error` values set by the NextAuth `jwt()` callback when the
 * Entra `id_token` can no longer be refreshed. When present the session is
 * still reported as `authenticated`, but the stale `id_token` will be
 * rejected downstream (401) — so the client must force a re-auth to recover.
 */
export const SESSION_ERROR = {
  /** The Entra `refresh_token` grant failed (expired/revoked/provider error). */
  REFRESH_TOKEN_ERROR: 'RefreshTokenError',
  /** The `id_token` expired and no `refresh_token` was available. */
  NO_REFRESH_TOKEN: 'NoRefreshToken',
  /**
   * A valid `id_token` was obtained but the `POST /api/bootstrap` call did not
   * return a user context, so the session has no internal user id. Unlike the
   * token errors above, the token itself is fine — re-authenticating won't fix
   * it (and would loop), so the client degrades the UI instead and lets
   * bootstrap retry on the next token refresh.
   */
  BOOTSTRAP_ERROR: 'BootstrapError',
} as const;

/** Query-string error codes used by linked-account auth callbacks. */
export const AUTH_CALLBACK_ERROR = {
  MISSING_PARAMS: 'missing_params',
  LINK_FAILED: 'link_failed',
} as const;
